import { BestSellerNotificationProps } from '../types';
import styles from './BestSellerNotification.module.scss';
import cx from 'classnames';
export const BestSellerNotification = ({
  children,
}: BestSellerNotificationProps) => {
  return (
    <div
      className={cx(
        styles['equipment-icon-card'],
        'col-md-5 col-12 text-center'
      )}
    >
      {children}
    </div>
  );
};
